import {HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {inject} from '@angular/core';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {switchMap, take} from 'rxjs/operators';
import {Observable} from 'rxjs';

export const authenticationInterceptor: HttpInterceptorFn =
  (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const oidcService = inject(OidcSecurityService);

    // Skip auth header for OIDC endpoints
    if (req.url.includes('/.well-known/') || req.url.includes('/oauth/') || req.url.includes('/token')) {
      return next(req);
    }

    return oidcService.getAccessToken().pipe(
      take(1),
      switchMap(token => {
        if (token) {
          const clonedReq = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${token}`)
          });
          return next(clonedReq);
        }
        return next(req);
      })
    );
  };
